<template>
  <el-container>
    <el-header style="height: auto">
      <el-card v-loading="loading">
        <div slot="header">
          <span>办理意见</span>
        </div>
        <div>
          <el-radio v-model="back" :label="true">退回</el-radio>
          <el-radio v-model="back" :label="false">入库</el-radio>
        </div>
        <div v-show="back" class="msg-item">
          <el-input
            type="textarea"
            placeholder="请输入退回的意见"
            maxlength="500"
            show-word-limit
            v-model="feedback"
          ></el-input>
        </div>
        <div class="msg-item">
          <el-link @click="handleNext" v-show="hasNext">查看下一个>></el-link>
          <el-button type="primary" size="small" @click="handleSubmit">
            确认保存
          </el-button>
        </div>
      </el-card>
    </el-header>
    <el-main>
      <div><Base ref="Base"></Base></div>
    </el-main>
  </el-container>
</template>

<script>
import Base from './components/Base.vue';
import { flowInf, flowAudit, flowBack } from '@/api/position/mavin/flow.js';

export default {
  data() {
    return {
      loading: false,
      back: null,
      feedback: '',
      hasNext: false
    };
  },
  components: {
    Base
  },
  methods: {
    handleSubmit() {
      if (this.back == null) {
        this.$alert('请选择[退回]或[入库]！', '提示', {
          confirmButtonText: '确定'
        });
        return;
      }

      if (this.back && this.feedback.length == 0) {
        this.$alert('请填写请退回的意见', '提示', {
          confirmButtonText: '确定'
        });
        return;
      }

      this.loading = true;

      if (this.back) {
        flowBack(this.$route.params.mavinEid, {
          feedback: this.feedback
        }).then(() => {
          this.success();
        });
      } else {
        flowAudit(this.$route.params.mavinEid).then(() => {
          this.success();
        });
      }
    },
    handleNext() {
      if (!this.hasNext) {
        window.close();
      }

      window.location = `/position/base/review/audit/${this.nextMavinEid}`;
    },
    success() {
      let message = '为您自动打开下一个专家信息。';
      if (this.nextMavinEid == null) {
        message = '审核完成，关闭此页面。';
      }

      this.msgSuccess(`保存成功，${message}`, () => {
        this.feedback = '';
        this.back = null;
        this.handleNext();
      });
    },
    show() {
      //获取下一个并显示。
      this.loading = true;
      flowInf('audit', this.$route.params.mavinEid).then(res => {
        this.nextMavinEid = res.nextMavinEid;
        this.loading = false;
        this.hasNext = !!this.nextMavinEid;
      });
    }
  },
  created() {
    this.show();
  }
};
</script>

<style lang="scss" scoped>
.msg-item {
  margin-top: 10px;
}
</style>
